import React, { useState, useRef } from 'react';
import { Box, Button, Typography, Avatar } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import FileUploadIcon from '@mui/icons-material/CloudUpload';
import { useTheme } from '@mui/material/styles';

const UploadAvatar = ({ onSelectAvatar }) => {
  const theme = useTheme();
  const [file, setFile] = useState(null);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [photo, setPhoto] = useState(null); // To store the captured photo
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(URL.createObjectURL(selectedFile));
      onSelectAvatar(selectedFile);  // Pass selected image to parent component
    }
  };

  const handleCameraCapture = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const video = document.createElement('video');
      video.srcObject = stream;
      video.play();

      video.onloadedmetadata = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0);

        const imageSrc = canvas.toDataURL('image/png');
        setPhoto(imageSrc);
        onSelectAvatar(imageSrc); // Pass captured image to parent component
        stream.getTracks().forEach(track => track.stop());
        setIsCameraActive(false); // Close camera
      };
    } catch (err) {
      console.error('Error accessing camera:', err);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: '350', color: 'Black' }}>Upload or Capture Image</Typography>

      <Button
        variant="outlined"
        component="label"
        sx={{
          borderColor: theme.palette.brand.main, 
          color: theme.palette.brand.main, 
          fontWeight: 'bold',
          width: 300, 
          '&:hover': {
            borderColor: theme.palette.brand.main,
            bgcolor: theme.palette.brand.main,
            color: theme.palette.getContrastText(theme.palette.brand.main),
          },
        }}
      >
        <FileUploadIcon sx={{ mr: 1 }} />
        Choose from Device
        <input
          type="file"
          hidden
          onChange={handleFileChange}
          ref={fileInputRef}
          accept="image/*"
        />
      </Button>

      <Button
        variant="outlined"
        sx={{
          borderColor: theme.palette.brand.main, 
          color: theme.palette.brand.main, 
          fontWeight: 'bold',
          width: 300,
          '&:hover': {
            borderColor: theme.palette.brand.main,
            bgcolor: theme.palette.brand.main,
            color: theme.palette.getContrastText(theme.palette.brand.main),
          },
        }}
        onClick={handleCameraCapture}
      >
        <PhotoCameraIcon sx={{ mr: 1 }} />
        Take a Photo
      </Button>

      {(file || photo) && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Avatar
            src={file || photo}
            alt="Selected Avatar"
            sx={{ width: 100, height: 100, border: `3px solid ${theme.palette.brand.main}` }}
          />
        </Box>
      )}
    </Box>
  );
};

export default UploadAvatar;
